import api from "../api/PrivateApi";
import { useEffect, useState } from "react";
import  useRefreshToken  from "./useRefreshToken";
import useAuth from "./useAuth";
import GetCookie from "./getCookie";
import {useNavigate} from 'react-router-dom'
import RemoveCookie from '../hooks/removeCookie'
import ClearToken from '../hooks/clearToken';

const useAxiosPrivate=()=>{
    const refresh=useRefreshToken();
    // const auth=GetCookie('auth')
    // const [user, setUser] = useState(auth?JSON.parse(auth):null);
    const {user,setUser}=useAuth()
    const navigate=useNavigate()
    const remove=ClearToken()
    useEffect(()=>{
        const requestIntercept=api.interceptors.request.use(
            config=>{
                if(!config.headers['Authorization']){
                    config.headers['Authorization']=`Bearer ${user?.accessToken}`
                }
                return config;
            },(error)=>Promise.reject(error)
        );
        const responseIntercept=api.interceptors.response.use(
            response=>response,
            async(error)=>{
                const prevRequest=error?.config;
                if(error?.response?.status===403 && !prevRequest?.sent){
                    prevRequest.sent=true;
                    const newAccessToken=await refresh();
                    // setUser((prevUser)=>{return {...prevUser,accessToken:newAccessToken}})
                    prevRequest.headers['Authorization']=`Bearer ${newAccessToken}`
                    return api(prevRequest)
                }

                return Promise.reject(error)
            }
        );
        return ()=>{
            api.interceptors.response.eject(responseIntercept)
            api.interceptors.request.eject(requestIntercept)
        }
    },[user,refresh])
    return api;
}

export default useAxiosPrivate;